import { validationConfig as config } from './validation';

export const validationConfig: typeof config = {
  dob: {
    required: false,
  },
  phoneNumber: {
    required: false,
  },
  zipcode: {
    required: false,
  },
};
